
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dog-shipping/[breed]",
      function () {
        return require("private-next-pages/dog-shipping/[breed].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dog-shipping/[breed]"])
      });
    }
  